function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3175 2.4839C18.3175 4.34875 20.2118 4.23573 20.7307 3.28276C21.0639 2.67141 21.5726 2.30409 22.256 2.8067C23.0774 3.41033 22.141 4.25371 21.4891 4.90273C21.2701 5.12192 21.0784 5.3454 20.8457 5.54062C20.1291 6.13997 19.5744 6.79498 19.0086 7.54675C18.7777 7.85328 18.1445 8.79256 18.1445 9.24721C18.1445 10.0178 18.8032 10.6172 19.5931 10.6172H23.8537C25.4259 10.6172 25.6994 8.47661 24.2977 8.03052C23.9202 7.90979 22.7161 7.96288 22.1495 7.96288C22.9164 6.80697 25.2171 5.59028 25.2171 3.42489C25.2171 1.6996 23.5981 0 21.8938 0C20.7716 0 20.3149 0.0856223 19.4227 0.770601C19.0776 1.03432 18.3175 1.92735 18.3175 2.4839Z",
  fill: "#1C2A40"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7191 1.28482C36.7191 2.8363 38.5042 2.65478 39.2754 2.65478C39.0308 3.0221 38.7394 3.33976 38.471 3.72934C37.9938 4.41946 38.154 5.25085 38.834 5.66612C39.6077 6.13961 40.6388 5.38442 40.6388 7.10629C40.6388 8.00704 39.4671 8.21338 39.0095 7.71592C38.8749 7.56865 38.8502 7.41281 38.73 7.22701C38.5231 6.92542 38.2057 6.71853 37.8473 6.65163C37.0999 6.48039 36.2913 7.16536 36.3211 7.95309C36.3433 8.53275 36.9968 9.46861 37.3863 9.77599C39.9699 11.8147 43.2803 9.88473 43.2803 7.02152C43.2803 5.60618 42.5782 4.34154 41.6613 3.85349C42.1453 2.93391 43.1951 2.1342 43.1951 1.28482C43.1951 0.590426 42.5543 0.000488281 41.8317 0.000488281H38.0824C37.2235 0.000488281 36.7191 0.818181 36.7191 1.28482Z",
  fill: "#1C2A40"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.72602 4.53798V7.96288C1.77592 7.96288 0.595736 7.89866 0.595736 9.41846C0.595736 10.0486 1.23312 10.6172 2.12954 10.6172H5.96406C8.15741 10.6172 7.76884 7.96288 6.30491 7.96288H5.36758V1.36996C5.36758 0.64388 4.78048 0 4.08941 0C3.27394 0 2.65019 0.889616 2.19345 1.34855C1.63276 1.91195 1.13853 2.41455 0.574433 2.97538C-0.757423 4.29139 0.641751 5.73241 1.75802 5.28204C2.30593 5.05942 2.32297 4.80941 2.72602 4.53798Z",
  fill: "#1C2A40"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.067 16.4388C41.067 17.0981 40.4603 17.8088 39.7889 17.8088C38.6487 17.8088 38.0429 16.4508 38.7859 15.6023C39.0884 15.2598 39.6585 15.0885 40.1783 15.2735C40.7637 15.4807 41.067 16.0817 41.067 16.4388ZM35.8691 16.1819V16.7813C35.8691 18.552 37.6858 20.3774 39.448 20.3774H40.0445C41.8178 20.3774 43.6234 18.5588 43.6234 16.7813C43.6234 15.419 43.4393 14.663 42.4534 13.6758C40.0573 11.2792 35.8691 13.1303 35.8691 16.1819Z",
  fill: "#1C2A40"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7244 17.8084C20.096 17.8084 19.923 15.2295 21.7355 15.1832C23.4005 15.1413 23.3809 17.8084 21.7244 17.8084ZM17.8047 16.5241C17.8047 17.5764 18.3321 18.6004 18.846 19.1587C20.6806 21.1502 24.2092 20.6999 25.3041 17.9814C25.9219 16.4479 25.5956 14.8801 24.5142 13.8047C23.5505 12.8466 22.8756 12.5854 21.4679 12.5854C19.5822 12.5854 17.8055 14.3561 17.8055 16.5241H17.8047Z",
  fill: "#1C2A40"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.06676 16.2674C2.67308 16.0028 1.58835 14.3152 0.360448 15.4309C0.047722 15.7152 0 16.0671 0 16.5243C0 17.1236 0.898129 17.8086 1.25687 18.1725C1.84057 18.759 2.24191 19.4354 3.06761 19.4354C3.84559 19.4354 4.32704 18.7265 4.75054 18.3009L7.56252 15.4754C8.24932 14.7853 8.77678 14.4411 8.77678 13.5275C8.77678 12.8956 8.04056 12.2671 7.36057 12.3579C6.586 12.4615 4.97465 14.2716 4.41822 14.8838C4.40117 14.9026 4.35516 14.9565 4.33812 14.9737L3.75016 15.5816C3.56166 15.8466 3.33072 16.0783 3.06676 16.2674Z",
  fill: "#1C2A40"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3809 23.63C17.3809 24.4863 17.9594 25 18.7442 25H24.9647C26.7311 25 26.8138 22.3457 24.8795 22.3457H18.9147C18.0753 22.3457 17.3809 22.8055 17.3809 23.63Z",
  fill: "#1C2A40"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.6953 16.6096C31.6953 18.2099 34.1664 18.2064 34.1664 16.6096C34.1624 16.2878 34.035 15.98 33.8107 15.7503C33.5864 15.5206 33.2825 15.3867 32.9624 15.3766C32.2926 15.3561 31.6953 15.8296 31.6953 16.6096Z",
  fill: "#1C2A40"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8867 16.6096C13.8867 18.2039 16.3579 18.2133 16.3579 16.6096C16.3579 15.8998 15.8466 15.3946 15.1538 15.3766C14.8232 15.3716 14.504 15.4986 14.2665 15.7297C14.0289 15.9609 13.8923 16.2773 13.8867 16.6096Z",
  fill: "#1C2A40"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.1142 17.8088C28.53 17.8088 28.8393 17.8268 29.1878 17.432C30.1712 16.319 28.6399 14.5962 27.4078 15.729C26.6732 16.4037 27.1615 17.8088 28.1142 17.8088Z",
  fill: "#1C2A40"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.28516 16.4388C9.28516 17.4192 9.73933 17.8087 10.6485 17.8087C12.2531 17.8087 11.9523 14.8667 10.0921 15.4456C9.67713 15.5748 9.28516 15.9516 9.28516 16.4388Z",
  fill: "#1C2A40"
});

var SvgStepsSignup = function SvgStepsSignup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 25,
    viewBox: "0 0 44 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStepsSignup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steps-signup.1b9c843c.svg";
export { ForwardRef as ReactComponent };